function Resultats({ resultatsVote }) {
    return (
        <div className="custom-resultats-outer">
        <h3>Résultats</h3>

            <div className="custom-resultats-inner">
                {resultatsVote
                    .slice() 
                    .sort((a, b) => a.index - b.index)
                    .map((resultat, index) => (
                        <div key={index}>
                            <p className="mt-2">{resultat.label}</p>
                            <progress value={resultat.percentage} max={100} className="mt-n5"></progress>
                            <span>{resultat.percentage}%</span>

                        </div>
                    ))}
            </div>
        </div>
    )
}
export default Resultats;